import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LoaderService {
  loading = new BehaviorSubject<boolean>(false);
  consoleOutputEnabled = false;

  startLoading(): void {
    if (this.consoleOutputEnabled) console.log("LoaderService.startLoading");
    this.loading.next(true);
  }

  dismissLoading(): void {
    if (this.consoleOutputEnabled) console.log("LoaderService.dismissLoading");
    this.loading.next(false);
  }
}
